<template>
  <div :class="customClass">
    <carousel
      class="unlocked-badges"
      :perPageCustom="[
        [1920, 5],
        [1366, 4],
        [736, 3],
        [300, 2],
      ]"
      :centerMode="true"
      :paginationEnabled="false"
      :scrollPerPage="false"
      :navigationEnabled="true"
      :spacePadding="16"
      :touchDrag="true"
      :loop="true"
    >
      <slide v-for="(item, idx) in badges" :key="idx" class="d-flex px-2 justify-content-center">
        <div class="slide-card my-2 my-md-5 d-flex flex-column  bg-white shadow-sm">
          <div class="slide-image">
            <i
              v-if="!item || (item && !item.image)"
              class="material-icons cursor h1 m-0 p-0 text-secondary text-warning"
            >
              local_police
            </i>
            <img
              v-if="item && item.image"
              fluid
              :src="item.image"
              :class="item.score == item.score_requirement ? '' : ''"
              class="rounded"
              alt="image"
            />
          </div>
          <div
            class="slide-info d-flex flex-column justify-content-between"
            :class="userIsAParent ? 'progress-light' : 'progress-light2'"
          >
            <label class="slide-title">{{ item.name }}</label>
            <div class="slide-progress">
              <label class="slide-progress-text">100%</label>
              <b-progress
                :value="item && item.score ? 0 * 100 : 0"
                :max="100"
                variant="warning"
                class="slide-progress-bar"
              ></b-progress>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';

export default {
  components: {
    Carousel,
    Slide,
  },
  props: {
    customClass: String,
    badges: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('user', ['userIsAParent']),
  },
};
</script>
<style lang="scss">
.Badges {
  width: 100%;

  .VueCarousel-navigation {
    position: initial;
    .VueCarousel-navigation-button {
      height: 100%;
      // Small devices (landscape phones, 576px and up)
      @media (min-width: 320px) {
        padding-right: 1rem !important;
        padding-left: 1rem !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
* {
  position: relative;
  margin: 0;
  padding: 0;
}

.Badges {
  .unlocked-badges {
    margin: auto;
    max-width: 1600px;

    // Small devices (landscape phones, 576px and up)
    @media (min-width: 576px) {
      width: 85%;
    }

    .slide-card {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 0px !important;
      border-radius: 9px;
      overflow: hidden;
      width: 100%;

      .slide-image {
        width: 100%;
      }

      .slide-image {
        img,
        i {
          border-radius: 15px;
          width: 100%;
          height: 142px;
          object-fit: cover;
        }
      }

      .slide-info {
        width: 100%;
        flex-grow: 1;
        padding: 10px;
        gap: 1rem;

        .slide-title {
          font-size: calc(0.6vw + 0.5rem);
          font-weight: 600;
        }

        .slide-progress {
          display: flex;
          flex-direction: column;
          width: 100%;
          height: auto;

          .slide-progress-text {
            font-size: calc(0.6vw + 0.5rem);
            font-weight: 600;
            margin-left: auto;
          }

          .slide-progress-bar {
            width: 100%;
            height: 5px;
            background: rgb(93, 223, 191);
            background: linear-gradient(
              269deg,
              rgba(93, 223, 191, 1) 0%,
              rgba(206, 255, 70, 1) 100%
            );
          }
        }
      }
    }
  }
}
</style>
